import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { BodySecondary, H5 } from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { useEffect } from 'react';

import { ExcludedHousesTable } from '@/components/Modals/ExcludeHouses/ExcludedHousesTable';
import { useExcludeHouses } from '@/components/Modals/ExcludeHouses/hooks/useExcludeHouses';
import { HousesToExcludeTable } from '@/components/Modals/ExcludeHouses/HousesToExcludeTable';

type ApplyReadyParams = { handleApply: () => Promise<void>; hasChanges: boolean };

type Props = {
    onApplyReady?: (params: ApplyReadyParams | null) => void;
};

export const PreferencesFiltersExcludeHouses = ({ onApplyReady }: Props) => {
    const {
        handleApplyExcludeHouses,
        handleRemoveHouse,
        handleSelectHouse,
        hasExcludedHousesChanges,
        hasHousesToExcludeChanges,
        housesToExcludeData,
        localExcludedHouses,
    } = useExcludeHouses();

    useEffect(() => {
        onApplyReady?.({
            handleApply: handleApplyExcludeHouses,
            hasChanges: hasExcludedHousesChanges || hasHousesToExcludeChanges,
        });
        return () => onApplyReady?.(null);
    }, [onApplyReady, handleApplyExcludeHouses, hasExcludedHousesChanges, hasHousesToExcludeChanges]);

    return (
        <div className="flex flex-col">
            <ExcludedHousesTable
                className={cn(hasExcludedHousesChanges ? 'mb-2xs' : 'mb-md')}
                houseData={localExcludedHouses}
                onRemoveHouse={handleRemoveHouse}
            />
            {hasExcludedHousesChanges && (
                <BodySecondary className="mb-md flex text-text-secondary">
                    <FormattedMessage id="excludeAuctionHousesFilter.modal.nonAppliedChanges" />
                </BodySecondary>
            )}
            {housesToExcludeData.length > 0 ? (
                <HousesToExcludeTable
                    houseData={housesToExcludeData}
                    onSelectHouse={handleSelectHouse}
                />
            ) : (
                <H5>
                    <FormattedMessage id="excludeAuctionHousesFilter.modal.noHousesToExclude" />
                </H5>
            )}
        </div>
    );
};
